// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"Languages_languageSwitcher__bofW7","languageItem":"Languages_languageItem__DFoRM","separator":"Languages_separator__j_mC1"};